import React, { useState } from 'react';
import { Container } from "./styles";
import { FiShield, FiFileText } from "react-icons/fi";
import TaxMonitoring from "../tax-monitoring";
import DEC from "../dec";

export default function NotificacoesFiscais() {
  const [activeTab, setActiveTab] = useState('ecac');

  return (
    <Container>
      <div className="content-wrapper">
        <div className="header-info">
          <div className="header-details">
            <h3>Notificações Fiscais</h3>
            <div className="header-meta">
              <span className="status-tag">Sistema Ativo</span>
              <span className="update-tag">{activeTab === 'ecac' ? 'e-CAC / Receita Federal' : 'DEC / Sefaz SP'}</span>
            </div>
          </div>
        </div>

        <div className="tabs-header">
          <button
            className={`tab ${activeTab === 'ecac' ? 'active' : ''}`}
            onClick={() => setActiveTab('ecac')}
          >
            <FiShield />
            e-CAC
          </button>
          <button
            className={`tab ${activeTab === 'dec' ? 'active' : ''}`}
            onClick={() => setActiveTab('dec')}
          >
            <FiFileText />
            DEC
          </button>
        </div>

        <div className="embedded-content">
          {activeTab === 'ecac' ? (
            <TaxMonitoring embedded />
          ) : (
            <DEC embedded />
          )}
        </div>
      </div>
    </Container>
  );
}
